import defaultImg from "../../assets/default_img.png";
import {
  createGroupActionButtons,
  createProductActionButtons,
  createStatusTag,
  renderKeywordGroups,
  renderKeywordsCount,
  STYLES,
} from "./productConstants";

/**
 * Transform products to table row data.
 * keywordGroupMap - map of keyword group ID -> name (PRODUCT_KEYWORD_GROUP type)
 * productGroupMap - map of product group ID -> name (PRODUCT_GROUP type)
 */
export const transformProductsToRowData = (
  products,
  keywordGroupMap,
  productGroupMap,
  onView,
  onEdit,
  onDelete
) => {
  return products.map((product) => {
    const groupIds = product.keywordsGroupIds || [];

    // Keyword group names (those in keywordGroupMap)
    const keywordGroupNames = groupIds
      .map((id) => keywordGroupMap?.[id] || null)
      .filter(Boolean);

    // Product group names (those in productGroupMap)
    const productGroupNames = groupIds
      .map((id) => productGroupMap?.[id] || null)
      .filter(Boolean);

    const totalKeywords = (product.keywords || []).length;

    return {
      image: (
        <img
          src={product.imageUrl || defaultImg}
          alt={product.name}
          style={STYLES.productImage}
        />
      ),
      name: product.name,
      ean_upc: product.metadata?.ean_upc || "-",
      keywordGroups: renderKeywordGroups(keywordGroupNames),
      keywords: renderKeywordsCount(totalKeywords),
      productGroup:
        productGroupNames.length > 0 ? productGroupNames.join(", ") : "-",
      status: createStatusTag(product.deleted),
      actions: createProductActionButtons(product, onView, onEdit, onDelete),
    };
  });
};

export const transformProductGroupsToRowData = (
  groups,
  allProducts,
  onViewGroup,
  onEditGroup,
  onDeleteGroup
) => {
  return groups.map((group) => {
    // Count products that have this group ID in their keywordsGroupIds
    const productCount = allProducts.filter((p) =>
      (p.keywordsGroupIds || []).includes(group.id)
    ).length;

    return {
      id: group.id,
      name: group.name,
      productCount,
      actions: createGroupActionButtons(
        group,
        onViewGroup,
        onEditGroup,
        onDeleteGroup
      ),
    };
  });
};
